import { classNames } from '@payfit/growth-platform-brand-system-v2/utils/style';

export const numberEmployeeStyle = classNames(
  'border border-[#EBF0F5]',
  'bg-[#F7F9FC] text-[#042040]',
  'px-[6px] py-[1px] rounded-[6px]',
);
